import { render } from "./CombinedPage.vue?vue&type=template&id=2f80d029&scoped=true"
import script from "./CombinedPage.vue?vue&type=script&lang=js"
export * from "./CombinedPage.vue?vue&type=script&lang=js"

import "./CombinedPage.vue?vue&type=style&index=0&id=2f80d029&scoped=true&lang=css"
import "./CombinedPage.vue?vue&type=style&index=1&id=2f80d029&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f80d029"]])

export default __exports__